import React, { useState } from 'react';
import {
  buildTarotSharePayload,
  buildLineShareUrl,
  buildFacebookShareUrl,
  buildWhatsAppShareUrl,
  recordShare,
} from 'viral/viralShare';

export default function TarotShareCard({ reading }) {
  const [copied, setCopied] = useState(false);

  if (!reading) return null;

  const { url, text } = buildTarotSharePayload(reading, 'native');
  const lineUrl = buildLineShareUrl(text, buildTarotSharePayload(reading, 'line').url);
  const facebookUrl = buildFacebookShareUrl(buildTarotSharePayload(reading, 'facebook').url);
  const whatsappUrl = buildWhatsAppShareUrl(text, buildTarotSharePayload(reading, 'whatsapp').url);

  const cardNames = reading.positions.map((p) => p.card.nameTh).join(' · ');

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: 'Hotto ไพ่ยิปซี', text, url });
        recordShare('tarot_native');
        return;
      } catch {
        /* cancelled */
      }
    }
    handleCopy();
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`${text}\n${url}`);
      recordShare('tarot_copy');
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <aside className="viral-share viral-share--result" aria-label="แชร์คำทำนายไพ่">
      <div className="viral-share__header">
        <span className="viral-share__emoji" aria-hidden="true">🔮</span>
        <div>
          <p className="viral-share__hook">
            ชวนเพื่อนเปิดไพ่ด้วยกัน — {cardNames}
          </p>
          <p className="viral-share__sub">
            แชร์ลิงก์แล้วเพื่อนเห็นผลเดียวกัน พร้อมเลขนำโชคจากไพ่
          </p>
        </div>
      </div>

      <div className="viral-share__actions">
        <button type="button" className="viral-share__btn viral-share__btn--primary" onClick={handleNativeShare}>
          {copied ? 'คัดลอกแล้ว ✓' : 'แชร์คำทำนาย'}
        </button>
        <a
          href={lineUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="viral-share__btn viral-share__btn--line"
          onClick={() => recordShare('tarot_line')}
        >
          LINE
        </a>
        <a
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="viral-share__btn viral-share__btn--facebook"
          onClick={() => recordShare('tarot_facebook')}
        >
          Facebook
        </a>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="viral-share__btn viral-share__btn--whatsapp"
          onClick={() => recordShare('tarot_whatsapp')}
        >
          WhatsApp
        </a>
      </div>
    </aside>
  );
}
